/* eslint-disable react/no-danger */
// @flow
import * as React from 'react';
import classNames from 'classnames';
import _ from 'lodash';

import * as css from './Checkbox.scss';

type Props = {
	input: {
		name: string,
		onChange: Function,
		checked?: boolean,
	},
	meta: {
		touched?: boolean,
		error?: string,
		submitFailed?: boolean,
	},
	className?: string,
	label: React.Element<*>,
};

export default class Checkbox extends React.PureComponent<Props> {
	static defaultProps = {
		className: '',
	};

	render() {
		const { className, label, meta } = this.props;
		const isActive = _.get(this.props, 'input.checked');

		return (
			<label className={classNames(css.checkbox, isActive && css.active, meta.error && css.error, className)}>
				<div className={css.control} />
				<p>{label}</p>
				{meta.error && <div className={css.error}>{meta.error}</div>}
				<input {...this.props.input} type="checkbox" />
			</label>
		);
	}
}
